import axios from 'axios'

export default {
    namespaced: true,
    state: {
        captcha: {},
        userAnswer: '',
    },
    mutations: {
        setCaptcha(state, captcha) {
            state.captcha = captcha
        },
        setUserAnswer(state, answer) {
            state.userAnswer = answer
        },
    },
    actions: {
        getCaptcha({commit, state}) {
            axios.post(`/captcha`)
                .then(res => {
                    const data = res.data.data;
                    commit('setCaptcha', data)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        setUserAnswer({commit, state}, answer) {
            commit('setUserAnswer', answer)
        },
    },
    getters: {
        getCaptcha: state => state.captcha,
        getCaptchaId: state => state.captcha.id,
        getCaptchaStatus: state => state.captcha.status,
        getUserAnswer: state => state.userAnswer,
        getCaptchaForUrl: (state, getters) => {
            if (!getters.getCaptchaStatus) {
                return ''
            }

            return `captcha_answer=${state.userAnswer}&captcha_id=${state.captcha.id}`
        }
    },
}